import { FC } from "react";
import {
  genericLoadOptions,
  getLabelFromOptions,
} from "../../../../lib/DurationPicker/utils";
import { useEndpoints } from "../../../../hooks/useEndpoints";
import CustomSelectInput from "../../../CustomSelectInput/CustomSelectInput";
import style from "./SelectTeams.module.scss";
import { XIcon } from "@phosphor-icons/react";
import Typhography from "../../../Typhography/Typhography";
import { LEVELS_SPORT_OPTIONS } from "../../../../constants/config";
import { ITeam } from "../../../../models/Team";
import { CustomTeamOption } from "../../../../components/UserPage/AddUserModal/SecondTab/SecondTab";
import { ThemeContext } from "@emotion/react";
import { TypeSpaceIcon } from "../../../Icons/Icons";
import { LEVELS_BY_SPORT } from "../../../../enums/Space";

export const SelectTeams: FC<{
  label: string;
  onChange: (newValue: any) => void;
  value: any;
}> = ({ value, onChange }) => {
  const data = Array.isArray(value) ? value : [];
  const { getTeams } = useEndpoints();

  const promiseOptions = genericLoadOptions(
    getTeams,
    (team: ITeam<{ type: keyof typeof LEVELS_SPORT_OPTIONS }>) => ({
      label: team.name,
      value: team,
    }),
    {
      populate: "spaceId.type",
      sort: "-isPreferred",
    }
  );

  return (
    <div className="d-flex flex-column gap-3">
      <ThemeContext.Provider value={value}>
        <CustomSelectInput
          autoHeight
          label={`Cerca team`}
          onChange={(value) => {
            if (!data.some((item) => item._id === value.value._id))
              onChange([...data, value.value]);
          }}
          isOptionSelected={() => false}
          value={null}
          components={{
            Option: CustomTeamOption,
          }}
          placeholder="Cerca per nome"
          loadOptions={promiseOptions}
          menuPortalTarget={document.body}
          menuPosition="fixed"
        />
      </ThemeContext.Provider>
      <div className="d-flex flex-column gap-1">
        <Typhography size="bold-12">
          {value.length} team selezionati
        </Typhography>
        <div className={style.chipsContainer}>
          {value.map((team: any) => {
            const levelLabel = getLabelFromOptions(
              LEVELS_SPORT_OPTIONS[
                team.spaceId.type as keyof typeof LEVELS_BY_SPORT
              ],
              team.level
            );
            return (
              <div className={style.chip} key={team._id}>
                <span className={style.chipIcon}>
                  <TypeSpaceIcon type={team.spaceId.type} />
                </span>
                <Typhography size="bold-12" type="span">
                  {team.name}
                </Typhography>
                {levelLabel && levelLabel !== "error" && (
                  <span className={style.chipBadge}>
                    {levelLabel}
                  </span>
                )}
                <button
                  className={style.chipRemove}
                  type="button"
                  aria-label="Rimuovi team"
                  onClick={() => {
                    onChange(
                      value.filter((item: any) => item._id !== team._id)
                    );
                  }}
                >
                  <XIcon size={10} weight="bold" />
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
